module.exports = __webpack_public_path__ + "img/2.716ae2da.png";